import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_FORM_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    babysDateOfBirth: '',
    diagnosticImaging: [],
    isClaimRelatedToSelfInflictedYes: '',
    isClaimRelatedToSelfInflictedNo: '',
    didYouContactUsPriorToYourHospitalization: '',
    isYourClaimRelatedToPsychiatricTreatment: '',
    isYourClaimRelatedToHIV: '',
    isYourClaimRelatedToASelfInflictedInjuryOrSuicideAttempt: '',
    whatExpensesAreYouClaimingFor: [],
    infodDiagnosticNonMRIItems: [],
    infodDiagnosticMRIItems: [],
    infoOutpatientDoctorOrClinicVisitItems: [],
    infoOutpatientDoctorOrClinicVisitSelfInflictedInjuriesAndAttemptedSuicideItems: [],
    infoHospitalChargesRelatedToPsychiatricTreatmentItems: [],
    infoHospitalChargesRelatedToHIVItems: [],
    infoHospitalizationChargesItems: [],
    infoWellBabyCareItems: [],
    infoAnnualHealthExamItems: [],
    infoBloodPlasmaItems: [],
    infoAnaesthesiologyItems: [],
    infoDentalSurgeryItems: [],
    infoVaccinationExpensesItems: [],
    infoCleftLipAndPalateAssistanceItems: [],
    infoMaternityExpenseItems: [],
    infoOncologyItems: [],
    infoInPatientHospitalExpensesSelfInflictedInjuriesAndAttemptedSuicideItems: [],
  },
  errors: [],
});

function handleFormReset(state, { fields }) {
  // Only reset the specified fields to empty arrays or default values
  let newState = state;
  fields.forEach(field => {
    // Get the default value from initialState for this field
    const defaultValue = initialState.getIn(['form', field]);
    // Reset the field to its default value (empty array [] or empty string '')
    newState = newState.setIn(['form', field], defaultValue);
  });
  
  return newState;
}

function medicalExpensesTugoStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_FORM_STATE:
      return handleFormReset(state, action.payload);
    default:
      return state;
  }
}

export default medicalExpensesTugoStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.MedicalExpenses/reducer.js